import type { FilterListConfig } from '@/types/schema/page-configs/filter-list'

export const defaultFilterListConfig: FilterListConfig = {}
